// src/pages/Home/data/aboutData.js

import {
  FaCode,
  FaEuroSign,
  FaHeadset,
  FaLaptopCode,
  FaRocket,
  FaShieldAlt,
} from "react-icons/fa";

export const aboutProfile = {
  name: "Laurent VICTORIN",
  role: "Développeur Web FullStack indépendant",
  company: "MonAppliClub",
  location: "Bordeaux • Disponible partout en France",
  availability: "Disponible pour de nouveaux projets",
  phoneDisplay: "06.80.72.77.07",
  phoneHref: "tel:+33680727707",
  email: "monappliclub@gmail.com",
  emailHref: "mailto:monappliclub@gmail.com",
  vkardLink:
    "https://profile.vkard.io/8f8e4d95-cf28-40b0-afc6-2ec677889d49/ab099714aa",
  photo: "/images/LV.webp",
};

export const aboutServices = [
  {
    id: "development",
    eyebrow: "Développement",
    title: "Sites web et applications sur mesure",
    description:
      "Des outils modernes, responsive et simples à administrer, conçus autour de votre activité.",
    image: "/images/appli/illustration_website.png",
    icon: FaLaptopCode,
    points: [
      "Sites vitrines et portails publics",
      "Applications métier",
      "Espaces d’administration personnalisés",
    ],
  },
  {
    id: "support",
    eyebrow: "Accompagnement",
    title: "Formation et assistance à distance",
    description:
      "Je vous accompagne dans la prise en main, l’utilisation et l’évolution de votre application.",
    image: "/images/appli/formation_visio.webp",
    icon: FaHeadset,
    points: [
      "Formation en visioconférence",
      "Assistance personnalisée",
      "Évolutions selon vos besoins",
    ],
  },
];

export const aboutCommitments = [
  {
    icon: FaCode,
    title: "Un interlocuteur unique",
    text: "Vous échangez directement avec la personne qui imagine et développe votre projet.",
  },
  {
    icon: FaEuroSign,
    title: "Des tarifs adaptés",
    text: "Des solutions réalistes pour les clubs, associations, collectivités et petites structures.",
  },
  {
    icon: FaShieldAlt,
    title: "Des outils fiables",
    text: "Sécurité, sauvegarde, responsive et protection des données sont intégrées dès la conception.",
  },
  {
    icon: FaRocket,
    title: "Une solution évolutive",
    text: "Votre application peut progresser avec votre activité, vos utilisateurs et vos nouvelles idées.",
  },
];

export const aboutAudiences = [
  "Clubs sportifs",
  "Associations",
  "Collectivités",
  "Comités & ligues",
  "Entreprises",
  "Artisans",
  "Particuliers",
];